var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 0.000244141C10.4288 0.000244141 7.91543 0.762681 5.77759 2.19114C3.63975 3.6196 1.97351 5.64992 0.989572 8.02536C0.00563272 10.4008 -0.251811 13.0147 0.249797 15.5364C0.751405 18.0582 1.98954 20.3745 3.80762 22.1926C5.6257 24.0107 7.94208 25.2488 10.4638 25.7505C12.9856 26.2521 15.5995 25.9946 17.9749 25.0107C20.3503 24.0267 22.3807 22.3605 23.8091 20.2227C25.2376 18.0848 26 15.5714 26 13.0002C25.9963 9.55357 24.6254 6.24914 22.1883 3.81197C19.7511 1.37481 16.4467 0.00397198 13 0.000244141V0.000244141ZM13 23.8336C10.8574 23.8336 8.76286 23.1982 6.98133 22.0078C5.1998 20.8174 3.81126 19.1255 2.99131 17.146C2.17136 15.1664 1.95683 12.9882 2.37483 10.8868C2.79284 8.78531 3.82461 6.85499 5.33968 5.33992C6.85475 3.82485 8.78507 2.79308 10.8865 2.37507C12.988 1.95706 15.1662 2.1716 17.1457 2.99155C19.1253 3.8115 20.8172 5.20003 22.0076 6.98157C23.198 8.7631 23.8333 10.8576 23.8333 13.0002C23.8302 15.8725 22.6878 18.6261 20.6568 20.6571C18.6259 22.688 15.8722 23.8304 13 23.8336Z",
    fill: "#92908E",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 6.50024C12.7125 6.50024 12.437 6.61438 12.2338 6.81754C12.0306 7.02071 11.9165 7.29626 11.9165 7.58358V12.269L8.26459 14.557C8.02037 14.7095 7.84676 14.9529 7.78195 15.2334C7.71714 15.514 7.76644 15.8088 7.91901 16.0531C8.07157 16.2973 8.31491 16.4709 8.59548 16.5357C8.87605 16.6005 9.17087 16.5512 9.41509 16.3986L13.5751 13.7987C13.7323 13.7002 13.8615 13.563 13.9505 13.4002C14.0395 13.2375 14.0851 13.0546 14.0832 12.8692V7.58358C14.0832 7.29626 13.969 7.02071 13.7659 6.81754C13.5627 6.61438 13.2872 6.50024 12.9998 6.50024Z",
    fill: "#92908E",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0 0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHistory);
export default __webpack_public_path__ + "static/media/ic-history.6cfb12f7e50740a69354b6b00fb83ea8.svg";
export { ForwardRef as ReactComponent };